import React, { useState, useEffect } from "react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  updateDoc,
  addDoc,
} from "firebase/firestore";
import { firestore } from "../../firebase";

const db = firestore;

const StudentAdministrasjonsPanel = ({
  currentBusinessID,
  userInformation,
}) => {
  const [email, setEmail] = useState("");
  const [inviteStatus, setInviteStatus] = useState("idle"); // 'idle', 'inviting', 'success', 'error' 'missingEmail'
  const [associatedStudentOrgs, setAssociatedStudentOrgs] = useState([]);

  useEffect(() => {
    const fetchAssociatedStudentOrgs = async () => {
      if (!currentBusinessID) return;
      try {
        const q = query(
          collection(db, "studentOrgInvitations"),
          where("invitedBy", "==", currentBusinessID),
        );
        const snapshot = await getDocs(q);
        setAssociatedStudentOrgs(snapshot.docs.map((doc) => doc.data()));
      } catch (e) {
        console.error("Error fetching associated student organizations: ", e);
      }
    };
    fetchAssociatedStudentOrgs();
  }, [currentBusinessID, associatedStudentOrgs]);

  const onInvite = async () => {
    setInviteStatus("inviting");
    const userCollection = collection(db, "users");
    const existingSnap = await getDocs(
      query(userCollection, where("epost", "==", email)),
    );

    if (!existingSnap.empty) {
      const userDoc = existingSnap.docs[0];
      const userId = userDoc.id;
      if (userDoc.data().studentOrgInvited) {
        setInviteStatus("error");
        return;
      }
      try {
        const newInvitation = await addDoc(
          collection(db, "studentOrgInvitations"),
          {
            userId,
            status: "pending",
            invitedBy: currentBusinessID,
            emailSentTo: email,
            invitationSentTo: userId,
            SOName: userInformation.SOName,
            timestamp: new Date(),
          },
        );
        await updateDoc(doc(db, "users", userId), {
          studentOrgInvited: newInvitation.id,
          studentOrgInvitedName: userInformation.SOName,
          studentOrgInvitationAccepted: false,
        });
        setInviteStatus("success");
      } catch (e) {
        console.error("Error sending invitation: ", e);
        setInviteStatus("error");
      }
    } else {
      setInviteStatus("missingEmail");
    }
  };

  return (
    <>
      <div className='studentAdmin'>
        <h1>
          Administrer tilganger til studentforeninger ved{" "}
          {userInformation?.SOName}
        </h1>
        <div className='box' style={{ padding: "20px", paddingTop: "10px" }}>
          <p>
            Inviter en studentforening til å administrere sin egen side ved ved{" "}
            {userInformation?.SOName} ved å sende en invitasjon til deres
            e-postadresse.
            <br></br>
            Når de har akseptert invitasjonen, vil de kunne administrere sin
            egen side på Mapli, og du vil kunne se hvilke studentforeninger som
            er tilknyttet {userInformation?.SOName} i oversikten under.
          </p>
          <label>Epostadresse:</label>
          <br></br>
          <input
            type='email'
            style={{ width: "350px" }}
            placeholder='epostadresse'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <br></br>
          <button
            onClick={onInvite}
            style={{ marginTop: "10px" }}
            className='universalButtonRed'>
            Inviter
          </button>
          {inviteStatus === "success" && (
            <p style={{ color: "green", marginTop: "10px" }}>
              Invitasjon sendt!
            </p>
          )}
          {inviteStatus === "error" && (
            <p style={{ color: "red", marginTop: "10px" }}>
              Feil ved sending av invitasjon.
            </p>
          )}
          {inviteStatus === "missingEmail" && (
            <p style={{ color: "red", marginTop: "10px" }}>
              Ingen bruker funnet med den oppgitte e-postadressen.
            </p>
          )}
          {inviteStatus === "inviting" && (
            <p style={{ color: "black", marginTop: "10px" }}>
              Sender invitasjon...
            </p>
          )}
        </div>
      </div>
      <div
        className='box'
        style={{ marginTop: "20px", padding: "20px", paddingTop: "10px" }}>
        <h2>Studentforeninger tilknyttet {userInformation?.SOName}</h2>
        {associatedStudentOrgs.length > 0 ? (
          associatedStudentOrgs.map((org) => (
            <div key={org.userId} style={{ marginBottom: "10px" }}>
              <p>
                <strong>{org.emailSentTo}</strong> -{" "}
                <label
                  style={{
                    color:
                      org.status === "accepted"
                        ? "green"
                        : org.status === "declined"
                          ? "red"
                          : "black",
                  }}>
                  {org.status}
                </label>
              </p>
            </div>
          ))
        ) : (
          <p>Ingen studentforeninger tilknyttet {userInformation?.SOName}.</p>
        )}
      </div>
    </>
  );
};

export default StudentAdministrasjonsPanel;
